import P from "i18next";
import { default as it } from "i18next";
import { initReactI18next as pr, I18nextProvider as mr, useTranslation as vr } from "react-i18next";
import Ae, { useMemo as br, useEffect as gr } from "react";
const et = ["en", "hi", "gu", "ja", "ko", "zh-CN"], Q = "en", hr = ["common"], rt = [
  { code: "en", label: "English", nativeLabel: "English" },
  { code: "hi", label: "Hindi", nativeLabel: "हिन्दी" },
  { code: "gu", label: "Gujarati", nativeLabel: "ગુજરાતી" },
  { code: "ja", label: "Japanese", nativeLabel: "日本語" },
  { code: "ko", label: "Korean", nativeLabel: "한국어" },
  { code: "zh-CN", label: "Chinese", nativeLabel: "中文" }
], Er = { required: "Required", more: "more", submit: "Submit", save: "Save", cancel: "Cancel", filter: "Filter", reset: "Reset", search: "Search", edit: "Edit", delete: "Delete", add: "Add", update: "Update", close: "Close", confirm: "Confirm", back: "Back", next: "Next", finish: "Finish", loading: "Loading...", noData: "No data found", yes: "Yes", no: "No", actions: "Actions", status: "Status", name: "Name", email: "Email", phone: "Phone", date: "Date", description: "Description", viewAll: "View All", myAccount: "My Account", billingAndPlans: "Billing & Plans", helpAndSupport: "Help & Support", takeATour: "Take a Tour", language: "Language", phoneNumberRequired: "Phone number is required", create: "Create", enterMobileNumber: "Enter mobile number", saveAsDraft: "Save as draft", searchPlaceholder: "Search...", noRows: "No rows", salesBot: "SalesBot", admin: "Admin", logout: "Log Out", logoutConfirmation: "Are you sure you want to log out?", yourTimezone: "Your timezone is set to", allDateTimes: "All dates and times are displayed accordingly", exportedSuccessfully: "{{title}} exported successfully!", noDataForExport: "No data received for export.", show: "Show", export: "Export", exporting: "Exporting...", exportData: "Export Data", exportEmailConversationData: "Export Email Conversation Data", exportChatbotConversationData: "Export Chatbot Conversation Data", exportWhatsAppConversationData: "Export WhatsApp Conversation Data", exportInstagramConversationData: "Export Instagram Conversation Data", selectDateRange: "Select Date Range", endDateCannotBeBeforeStartDate: "End Date cannot be before Start Date", noResponseReceived: "No response received." }, yr = {
  common: Er
}, Dr = { required: "आवश्यक", more: "और", submit: "जमा करें", save: "सहेजें", cancel: "रद्द करें", filter: "फ़िल्टर", reset: "रीसेट", search: "खोजें", edit: "संपादित करें", delete: "हटाएं", add: "जोड़ें", update: "अपडेट करें", close: "बंद करें", confirm: "पुष्टि करें", back: "वापस", next: "आगे", finish: "समाप्त करें", loading: "लोड हो रहा है...", noData: "कोई डेटा नहीं मिला", yes: "हाँ", no: "नहीं", actions: "क्रियाएं", status: "स्थिति", name: "नाम", email: "ईमेल", phone: "फ़ोन", date: "तारीख", description: "विवरण", viewAll: "सभी देखें", myAccount: "मेरा खाता", billingAndPlans: "बिलिंग और प्लान", helpAndSupport: "सहायता और समर्थन", takeATour: "टूर लें", language: "भाषा", create: "बनाएं", phoneNumberRequired: "फ़ोन नंबर आवश्यक है", searchPlaceholder: "खोजें...", enterMobileNumber: "मोबाइल नंबर दर्ज करें", saveAsDraft: "ड्राफ्ट के रूप में सहेजें", noRows: "कोई पंक्ति नहीं", salesBot: "सेल्सबॉट", admin: "एडमिन", logout: "लॉग आउट", logoutConfirmation: "क्या आप वाकई लॉग आउट करना चाहते हैं?", yourTimezone: "आपका टाइम ज़ोन यह है", allDateTimes: "सभी तारीखों और समय इस अनुसार प्रदर्शित किए जाएंगे", exportedSuccessfully: "{{title}} सफलतापूर्वक निर्यात किया गया!", noDataForExport: "निर्यात के लिए कोई डेटा प्राप्त नहीं हुआ।", show: "दिखाएँ", export: "निर्यात", exporting: "निर्यात हो रहा है...", exportData: "डेटा निर्यात करें", exportEmailConversationData: "ईमेल वार्तालाप डेटा निर्यात करें", exportChatbotConversationData: "चैटबॉट वार्तालाप डेटा निर्यात करें", exportWhatsAppConversationData: "व्हाट्सएप वार्तालाप डेटा निर्यात करें", exportInstagramConversationData: "इंस्टाग्राम वार्तालाप डेटा निर्यात करें", selectDateRange: "तिथि सीमा चुनें", endDateCannotBeBeforeStartDate: "समाप्ति तिथि प्रारंभ तिथि से पहले नहीं हो सकती", noResponseReceived: "कोई प्रतिक्रिया प्राप्त नहीं हुई।" }, Rr = {
  common: Dr
}, Cr = { required: "જરૂરી", more: "વધુ", submit: "સબમિટ કરો", save: "સાચવો", cancel: "રદ કરો", filter: "ફિલ્ટર", reset: "રીસેટ", search: "શોધો", edit: "સંપાદિત કરો", delete: "કાઢો", add: "ઉમેરો", update: "અપડેટ કરો", close: "બંધ કરો", confirm: "પુષ્ટિ કરો", back: "પાછળ", next: "આગળ", finish: "સમાપ્ત કરો", loading: "લોડ થઈ રહ્યું છે...", noData: "કોઈ ડેટા મળ્યો નથી", yes: "હા", no: "ના", actions: "ક્રિયાઓ", status: "સ્થિતિ", name: "નામ", email: "ઈ-મેઈલ", phone: "ફોન", date: "તારીખ", description: "વર્ણન", viewAll: "બધા જુઓ", myAccount: "મારું ખાતું", billingAndPlans: "બિલિંગ અને પ્લાન", helpAndSupport: "મદદ અને સપોર્ટ", takeATour: "ટૂર લો", language: "ભાષા", create: "બનાવો", phoneNumberRequired: "ફોન નંબર આવશ્યક છે", searchPlaceholder: "શોધો...", enterMobileNumber: "મોબાઈલ નંબર દાખલ કરો", saveAsDraft: "ડ્રાફ્ટ તરીકે સાચવો", noRows: "કોઈ હારમાળા નથી", salesBot: "સેલ્સબોટ", admin: "એડમિન", logout: "લૉગ આઉટ", logoutConfirmation: "શું તમે ખરેખર લોગ આઉટ કરવા માંગો છો?", yourTimezone: "તમારો ટાઈમ ઝોન આ છે", allDateTimes: "બધી તારીખો અને સમય આ મુજબ દર્શાવવામાં આવશે", exportedSuccessfully: "{{title}} સફળતાપૂર્વક નિકાસ કરવામાં આવી!", noDataForExport: "નિકાસ માટે કોઈ ડેટા મળ્યો નથી.", show: "બતાવો", export: "નિકાસ કરો", exporting: "નિકાસ થઈ રહી છે...", exportData: "ડેટા નિકાસ કરો", exportEmailConversationData: "ઈમેલ વાર્તાલાપ ડેટા નિકાસ કરો", exportChatbotConversationData: "ચેટબોટ વાર્તાલાપ ડેટા નિકાસ કરો", exportWhatsAppConversationData: "વોટ્સએપ વાર્તાલાપ ડેટા નિકાસ કરો", exportInstagramConversationData: "ઇન્સ્ટાગ્રામ વાર્તાલાપ ડેટા નિકાસ કરો", selectDateRange: "તારીખ શ્રેણી પસંદ કરો", endDateCannotBeBeforeStartDate: "અંતિમ તારીખ પ્રારંભ તારીખ પહેલાં હોઈ શકે નહીં", noResponseReceived: "કોઈ પ્રતિસાદ મળ્યો નથી." }, xr = {
  common: Cr
}, _r = { required: "必須", more: "もっと", submit: "提出する", save: "保存", cancel: "キャンセル", filter: "フィルター", reset: "リセット", search: "検索", edit: "編集", delete: "消去", add: "追加", update: "アップデート", close: "近い", confirm: "確認する", back: "戻る", next: "次", finish: "仕上げる", loading: "読み込み中...", noData: "データが見つかりませんでした", yes: "はい", no: "いいえ", actions: "アクション", status: "状態", name: "名前", email: "電子メール", phone: "電話", date: "日付", description: "説明", viewAll: "すべて見る", myAccount: "私のアカウント", billingAndPlans: "請求とプラン", helpAndSupport: "ヘルプとサポート", takeATour: "ツアーに参加する", language: "言語", phoneNumberRequired: "電話番号は必須です", create: "作成する", enterMobileNumber: "携帯電話番号を入力してください", saveAsDraft: "下書きとして保存", searchPlaceholder: "検索...", noRows: "行がありません", salesBot: "セールスボット", admin: "管理者", logout: "ログアウト", logoutConfirmation: "ログアウトしてもよろしいですか?", yourTimezone: "タイムゾーンは次のように設定されています", allDateTimes: "すべての日付と時刻がそれに応じて表示されます", exportedSuccessfully: "{{title}} は正常にエクスポートされました。", noDataForExport: "エクスポート用のデータを受信しませんでした。", show: "見せる", export: "輸出", exporting: "エクスポート中...", exportData: "データのエクスポート", exportEmailConversationData: "電子メールの会話データをエクスポートする", exportChatbotConversationData: "チャットボットの会話データをエクスポートする", exportWhatsAppConversationData: "WhatsApp の会話データをエクスポートする", exportInstagramConversationData: "Instagram の会話データをエクスポートする", selectDateRange: "日付範囲の選択", endDateCannotBeBeforeStartDate: "終了日を開始日より前にすることはできません", noResponseReceived: "応答がありませんでした。" }, wr = {
  common: _r
}, Sr = { required: "필수의", more: "더", submit: "제출하다", save: "구하다", cancel: "취소", filter: "필터", reset: "다시 놓기", search: "찾다", edit: "편집하다", delete: "삭제", add: "추가하다", update: "업데이트", close: "닫다", confirm: "확인하다", back: "뒤쪽에", next: "다음", finish: "마치다", loading: "로드 중...", noData: "데이터가 없습니다", yes: "예", no: "아니요", actions: "행위", status: "상태", name: "이름", email: "이메일", phone: "핸드폰", date: "날짜", description: "설명", viewAll: "모두 보기", myAccount: "내 계정", billingAndPlans: "청구 및 요금제", helpAndSupport: "도움말 및 지원", takeATour: "둘러보기", language: "언어", phoneNumberRequired: "전화번호는 필수 항목입니다.", create: "만들다", enterMobileNumber: "휴대폰 번호를 입력하세요", saveAsDraft: "초안으로 저장", searchPlaceholder: "찾다...", noRows: "행 없음", salesBot: "세일즈봇", admin: "관리자", logout: "로그아웃", logoutConfirmation: "정말로 로그아웃하시겠습니까?", yourTimezone: "귀하의 시간대는 다음과 같이 설정되어 있습니다.", allDateTimes: "모든 날짜와 시간이 그에 따라 표시됩니다.", exportedSuccessfully: "{{title}}을(를) 성공적으로 내보냈습니다!", noDataForExport: "내보내기 위해 수신된 데이터가 없습니다.", show: "보여주다", export: "내보내다", exporting: "내보내는 중...", exportData: "데이터 내보내기", exportEmailConversationData: "이메일 대화 데이터 내보내기", exportChatbotConversationData: "챗봇 대화 데이터 내보내기", exportWhatsAppConversationData: "WhatsApp 대화 데이터 내보내기", exportInstagramConversationData: "Instagram 대화 데이터 내보내기", selectDateRange: "기간 선택", endDateCannotBeBeforeStartDate: "종료 날짜는 시작 날짜보다 이전일 수 없습니다.", noResponseReceived: "응답이 수신되지 않았습니다." }, Tr = {
  common: Sr
}, Ar = { required: "必需的", more: "更多的", submit: "提交", save: "节省", cancel: "取消", filter: "筛选", reset: "重置", search: "搜索", edit: "编辑", delete: "删除", add: "添加", update: "更新", close: "关闭", confirm: "确认", back: "后退", next: "下一个", finish: "结束", loading: "加载中...", noData: "没有找到数据", yes: "是的", no: "不", actions: "行动", status: "地位", name: "姓名", email: "电子邮件", phone: "电话", date: "日期", description: "描述", viewAll: "查看全部", myAccount: "我的账户", billingAndPlans: "账单和计划", helpAndSupport: "帮助与支持", takeATour: "参观一下", language: "语言", phoneNumberRequired: "电话号码为必填项", create: "创造", enterMobileNumber: "输入手机号码", saveAsDraft: "另存为草稿", searchPlaceholder: "搜索...", noRows: "没有行", salesBot: "销售机器人", admin: "行政", logout: "退出", logoutConfirmation: "您确定要退出吗？", yourTimezone: "您的时区设置为", allDateTimes: "所有日期和时间都会相应显示", exportedSuccessfully: "{{title}} 导出成功！", noDataForExport: "未收到导出数据。", show: "展示", export: "出口", exporting: "出口...", exportData: "导出数据", exportEmailConversationData: "导出电子邮件对话数据", exportChatbotConversationData: "导出聊天机器人对话数据", exportWhatsAppConversationData: "导出 WhatsApp 对话数据", exportInstagramConversationData: "导出 Instagram 对话数据", selectDateRange: "选择日期范围", endDateCannotBeBeforeStartDate: "结束日期不能早于开始日期", noResponseReceived: "没有收到回复。" }, Pr = {
  common: Ar
}, Or = { filterBy: "Filter By", column: "Column", selectColumn: "Select column", operator: "Operator", selectOperator: "Select operator", value: "Value", selectValue: "Select value", start: "Start", end: "End", applyFilter: "Apply Filter", clear: "Clear", columnError: "Please select a column.", operatorError: "Please select an operator.", rangeError: "Please fill both start and end values.", valueError: "Please enter a value." }, Fr = {
  tableFilterDrawer: Or
}, kr = { filterBy: "फ़िल्टर द्वारा", column: "कॉलम", selectColumn: "कॉलम चुनें", operator: "ऑपरेटर", selectOperator: "ऑपरेटर चुनें", value: "मान", selectValue: "मान चुनें", start: "शुरू", end: "अंत", applyFilter: "फ़िल्टर लागू करें", clear: "साफ़ करें", true: "सही", false: "गलत", columnError: "कृपया एक कॉलम चुनें।", operatorError: "कृपया एक ऑपरेटर चुनें।", rangeError: "कृपया शुरू और अंत दोनों मान भरें।", valueError: "कृपया एक मान दर्ज करें।" }, jr = {
  tableFilterDrawer: kr
}, Nr = { filterBy: "ફિલ્ટર દ્વારા", column: "કોલમ", selectColumn: "કોલમ પસંદ કરો", operator: "ઓપરેટર", selectOperator: "ઓપરેટર પસંદ કરો", value: "મૂલ્ય", selectValue: "મૂલ્ય પસંદ કરો", start: "શરૂઆત", end: "અંત", applyFilter: "ફિલ્ટર લાગુ કરો", clear: "સ્પષ્ટ", true: "સાચું", false: "ખોટું", columnError: "કૃપા કરીને કોલમ પસંદ કરો.", operatorError: "કૃપા કરીને ઓપરેટર પસંદ કરો.", rangeError: "કૃપા કરીને શરૂઆત અને અંત બંને મૂલ્યો ભરો.", valueError: "કૃપા કરીને મૂલ્ય દાખલ કરો." }, Ir = {
  tableFilterDrawer: Nr
}, Br = { filterBy: "フィルター条件", column: "カラム", selectColumn: "列を選択", operator: "オペレーター", selectOperator: "演算子の選択", value: "価値", selectValue: "値を選択してください", start: "始める", end: "終わり", applyFilter: "フィルターを適用する", clear: "クリア", columnError: "列を選択してください。", operatorError: "オペレーターを選択してください。", rangeError: "開始値と終了値の両方を入力してください。", valueError: "値を入力してください。" }, $r = {
  tableFilterDrawer: Br
}, Lr = { filterBy: "필터링 기준", column: "열", selectColumn: "열 선택", operator: "연산자", selectOperator: "연산자 선택", value: "값", selectValue: "값 선택", start: "시작", end: "끝", applyFilter: "필터 적용", clear: "분명한", columnError: "열을 선택하세요.", operatorError: "운영자를 선택해주세요.", rangeError: "시작 값과 끝 값을 모두 입력하세요.", valueError: "값을 입력하세요." }, Wr = {
  tableFilterDrawer: Lr
}, Vr = { filterBy: "过滤依据", column: "柱子", selectColumn: "选择列", operator: "操作员", selectOperator: "选择运营商", value: "价值", selectValue: "选择值", start: "开始", end: "结尾", applyFilter: "应用过滤器", clear: "清除", columnError: "请选择一列。", operatorError: "请选择运营商。", rangeError: "请填写开始值和结束值。", valueError: "请输入一个值。" }, Mr = {
  tableFilterDrawer: Vr
}, Z = {
  en: { common: yr, tableFilterDrawer: Fr },
  hi: { common: Rr, tableFilterDrawer: jr },
  gu: { common: xr, tableFilterDrawer: Ir },
  ja: { common: wr, tableFilterDrawer: $r },
  ko: { common: Tr, tableFilterDrawer: Wr },
  "zh-CN": { common: Pr, tableFilterDrawer: Mr }
};
function Yr(d) {
  if (!d) return Z;
  const s = {};
  for (const p of Object.keys(Z))
    s[p] = { ...Z[p] ?? {} };
  for (const [p, f] of Object.entries(d))
    s[p] = { ...s[p] ?? {}, ...f };
  return s;
}
function qr(d) {
  if (!d) return [];
  const s = /* @__PURE__ */ new Set();
  for (const p of Object.values(d))
    for (const f of Object.keys(p))
      s.add(f);
  return Array.from(s);
}
function Ur(d = Q, s) {
  if (P.isInitialized)
    return P.language !== d && P.changeLanguage(d), P;
  const p = [...hr, ...qr(s)], f = Yr(s);
  return P.use(pr).init({
    resources: f,
    lng: d,
    fallbackLng: Q,
    defaultNS: "common",
    ns: p,
    interpolation: { escapeValue: !1 },
    react: { useSuspense: !1 }
  }), P;
}
var Y = { exports: {} }, j = {};
var we;
function zr() {
  if (we) return j;
  we = 1;
  var d = Ae, s = /* @__PURE__ */ Symbol.for("react.element"), p = /* @__PURE__ */ Symbol.for("react.fragment"), f = Object.prototype.hasOwnProperty, I = d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, B = { key: !0, ref: !0, __self: !0, __source: !0 };
  function O(R, m, w) {
    var h, y = {}, C = null, $ = null;
    w !== void 0 && (C = "" + w), m.key !== void 0 && (C = "" + m.key), m.ref !== void 0 && ($ = m.ref);
    for (h in m) f.call(m, h) && !B.hasOwnProperty(h) && (y[h] = m[h]);
    if (R && R.defaultProps) for (h in m = R.defaultProps, m) y[h] === void 0 && (y[h] = m[h]);
    return { $$typeof: s, type: R, key: C, ref: $, props: y, _owner: I.current };
  }
  return j.Fragment = p, j.jsx = O, j.jsxs = O, j;
}
var N = {};
var Se;
function Gr() {
  return Se || (Se = 1, process.env.NODE_ENV !== "production" && (function() {
    var d = Ae, s = /* @__PURE__ */ Symbol.for("react.element"), p = /* @__PURE__ */ Symbol.for("react.portal"), f = /* @__PURE__ */ Symbol.for("react.fragment"), I = /* @__PURE__ */ Symbol.for("react.strict_mode"), B = /* @__PURE__ */ Symbol.for("react.profiler"), O = /* @__PURE__ */ Symbol.for("react.provider"), R = /* @__PURE__ */ Symbol.for("react.context"), m = /* @__PURE__ */ Symbol.for("react.forward_ref"), w = /* @__PURE__ */ Symbol.for("react.suspense"), h = /* @__PURE__ */ Symbol.for("react.suspense_list"), y = /* @__PURE__ */ Symbol.for("react.memo"), C = /* @__PURE__ */ Symbol.for("react.lazy"), $ = /* @__PURE__ */ Symbol.for("react.offscreen"), ee = Symbol.iterator, Pe = "@@iterator";
    function Oe(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = ee && e[ee] || e[Pe];
      return typeof r == "function" ? r : null;
    }
    var S = d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
          t[a - 1] = arguments[a];
        Fe("error", e, t);
      }
    }
    function Fe(e, r, t) {
      {
        var a = S.ReactDebugCurrentFrame, i = a.getStackAddendum();
        i !== "" && (r += "%s", t = t.concat([i]));
        var l = t.map(function(o) {
          return String(o);
        });
        l.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, l);
      }
    }
    var ke = !1, je = !1, Ne = !1, Ie = !1, Be = !1, re;
    re = /* @__PURE__ */ Symbol.for("react.module.reference");
    function $e(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === f || e === B || Be || e === I || e === w || e === h || Ie || e === $ || ke || je || Ne || typeof e == "object" && e !== null && (e.$$typeof === C || e.$$typeof === y || e.$$typeof === O || e.$$typeof === R || e.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === re || e.getModuleId !== void 0));
    }
    function Le(e, r, t) {
      var a = e.displayName;
      if (a)
        return a;
      var i = r.displayName || r.name || "";
      return i !== "" ? t + "(" + i + ")" : t;
    }
    function te(e) {
      return e.displayName || "Context";
    }
    function D(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case f:
          return "Fragment";
        case p:
          return "Portal";
        case B:
          return "Profiler";
        case I:
          return "StrictMode";
        case w:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case R:
            var r = e;
            return te(r) + ".Consumer";
          case O:
            var t = e;
            return te(t._context) + ".Provider";
          case m:
            return Le(e, e.render, "ForwardRef");
          case y:
            var a = e.displayName || null;
            return a !== null ? a : D(e.type) || "Memo";
          case C: {
            var i = e, l = i._payload, o = i._init;
            try {
              return D(o(l));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var x = Object.assign, F = 0, ae, ne, oe, ie, le, se, ue;
    function ce() {
    }
    ce.__reactDisabledLog = !0;
    function We() {
      {
        if (F === 0) {
          ae = console.log, ne = console.info, oe = console.warn, ie = console.error, le = console.group, se = console.groupCollapsed, ue = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        F++;
      }
    }
    function Ve() {
      {
        if (F--, F === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: x({}, e, {
              value: ae
            }),
            info: x({}, e, {
              value: ne
            }),
            warn: x({}, e, {
              value: oe
            }),
            error: x({}, e, {
              value: ie
            }),
            group: x({}, e, {
              value: le
            }),
            groupCollapsed: x({}, e, {
              value: se
            }),
            groupEnd: x({}, e, {
              value: ue
            })
          });
        }
        F < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = S.ReactCurrentDispatcher, U;
    function L(e, r, t) {
      {
        if (U === void 0)
          try {
            throw Error();
          } catch (i) {
            var a = i.stack.trim().match(/\n( *(at )?)/);
            U = a && a[1] || "";
          }
        return `
` + U + e;
      }
    }
    var z = !1, W;
    {
      var Me = typeof WeakMap == "function" ? WeakMap : Map;
      W = new Me();
    }
    function fe(e, r) {
      if (!e || z)
        return "";
      {
        var t = W.get(e);
        if (t !== void 0)
          return t;
      }
      var a;
      z = !0;
      var i = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var l;
      l = q.current, q.current = null, We();
      try {
        if (r) {
          var o = function() {
            throw Error();
          };
          if (Object.defineProperty(o.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(o, []);
            } catch (g) {
              a = g;
            }
            Reflect.construct(e, [], o);
          } else {
            try {
              o.call();
            } catch (g) {
              a = g;
            }
            e.call(o.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (g) {
            a = g;
          }
          e();
        }
      } catch (g) {
        if (g && a && typeof g.stack == "string") {
          for (var n = g.stack.split(`
`), b = a.stack.split(`
`), u = n.length - 1, c = b.length - 1; u >= 1 && c >= 0 && n[u] !== b[c]; )
            c--;
          for (; u >= 1 && c >= 0; u--, c--)
            if (n[u] !== b[c]) {
              if (u !== 1 || c !== 1)
                do
                  if (u--, c--, c < 0 || n[u] !== b[c]) {
                    var E = `
` + n[u].replace(" at new ", " at ");
                    return e.displayName && E.includes("<anonymous>") && (E = E.replace("<anonymous>", e.displayName)), typeof e == "function" && W.set(e, E), E;
                  }
                while (u >= 1 && c >= 0);
              break;
            }
        }
      } finally {
        z = !1, q.current = l, Ve(), Error.prepareStackTrace = i;
      }
      var A = e ? e.displayName || e.name : "", _ = A ? L(A) : "";
      return typeof e == "function" && W.set(e, _), _;
    }
    function Ye(e, r, t) {
      return fe(e, !1);
    }
    function qe(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function V(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return fe(e, qe(e));
      if (typeof e == "string")
        return L(e);
      switch (e) {
        case w:
          return L("Suspense");
        case h:
          return L("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case m:
            return Ye(e.render);
          case y:
            return V(e.type, r, t);
          case C: {
            var a = e, i = a._payload, l = a._init;
            try {
              return V(l(i), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var k = Object.prototype.hasOwnProperty, de = {}, pe = S.ReactDebugCurrentFrame;
    function M(e) {
      if (e) {
        var r = e._owner, t = V(e.type, e._source, r ? r.type : null);
        pe.setExtraStackFrame(t);
      } else
        pe.setExtraStackFrame(null);
    }
    function Ue(e, r, t, a, i) {
      {
        var l = Function.call.bind(k);
        for (var o in e)
          if (l(e, o)) {
            var n = void 0;
            try {
              if (typeof e[o] != "function") {
                var b = Error((a || "React class") + ": " + t + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[o] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw b.name = "Invariant Violation", b;
              }
              n = e[o](r, o, a, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (u) {
              n = u;
            }
            n && !(n instanceof Error) && (M(i), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", a || "React class", t, o, typeof n), M(null)), n instanceof Error && !(n.message in de) && (de[n.message] = !0, M(i), v("Failed %s type: %s", t, n.message), M(null));
          }
      }
    }
    var ze = Array.isArray;
    function G(e) {
      return ze(e);
    }
    function Ge(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Je(e) {
      try {
        return me(e), !1;
      } catch {
        return !0;
      }
    }
    function me(e) {
      return "" + e;
    }
    function ve(e) {
      if (Je(e))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ge(e)), me(e);
    }
    var be = S.ReactCurrentOwner, Ke = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ge, he;
    function He(e) {
      if (k.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Xe(e) {
      if (k.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ze(e, r) {
      typeof e.ref == "string" && be.current;
    }
    function Qe(e, r) {
      {
        var t = function() {
          ge || (ge = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function er(e, r) {
      {
        var t = function() {
          he || (he = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var rr = function(e, r, t, a, i, l, o) {
      var n = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: s,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: o,
        // Record the component responsible for creating this element.
        _owner: l
      };
      return n._store = {}, Object.defineProperty(n._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(n, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: a
      }), Object.defineProperty(n, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.freeze && (Object.freeze(n.props), Object.freeze(n)), n;
    };
    function tr(e, r, t, a, i) {
      {
        var l, o = {}, n = null, b = null;
        t !== void 0 && (ve(t), n = "" + t), Xe(r) && (ve(r.key), n = "" + r.key), He(r) && (b = r.ref, Ze(r, i));
        for (l in r)
          k.call(r, l) && !Ke.hasOwnProperty(l) && (o[l] = r[l]);
        if (e && e.defaultProps) {
          var u = e.defaultProps;
          for (l in u)
            o[l] === void 0 && (o[l] = u[l]);
        }
        if (n || b) {
          var c = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          n && Qe(o, c), b && er(o, c);
        }
        return rr(e, n, b, i, a, be.current, o);
      }
    }
    var J = S.ReactCurrentOwner, Ee = S.ReactDebugCurrentFrame;
    function T(e) {
      if (e) {
        var r = e._owner, t = V(e.type, e._source, r ? r.type : null);
        Ee.setExtraStackFrame(t);
      } else
        Ee.setExtraStackFrame(null);
    }
    var K;
    K = !1;
    function H(e) {
      return typeof e == "object" && e !== null && e.$$typeof === s;
    }
    function ye() {
      {
        if (J.current) {
          var e = D(J.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ar(e) {
      return "";
    }
    var De = {};
    function nr(e) {
      {
        var r = ye();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Re(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = nr(r);
        if (De[t])
          return;
        De[t] = !0;
        var a = "";
        e && e._owner && e._owner !== J.current && (a = " It was passed a child from " + D(e._owner.type) + "."), T(e), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, a), T(null);
      }
    }
    function Ce(e, r) {
      {
        if (typeof e != "object")
          return;
        if (G(e))
          for (var t = 0; t < e.length; t++) {
            var a = e[t];
            H(a) && Re(a, r);
          }
        else if (H(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var i = Oe(e);
          if (typeof i == "function" && i !== e.entries)
            for (var l = i.call(e), o; !(o = l.next()).done; )
              H(o.value) && Re(o.value, r);
        }
      }
    }
    function or(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === m || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === y))
          t = r.propTypes;
        else
          return;
        if (t) {
          var a = D(r);
          Ue(t, e.props, "prop", a, e);
        } else if (r.PropTypes !== void 0 && !K) {
          K = !0;
          var i = D(r);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", i || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ir(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var a = r[t];
          if (a !== "children" && a !== "key") {
            T(e), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a), T(null);
            break;
          }
        }
        e.ref !== null && (T(e), v("Invalid attribute `ref` supplied to `React.Fragment`."), T(null));
      }
    }
    var xe = {};
    function _e(e, r, t, a, i, l) {
      {
        var o = $e(e);
        if (!o) {
          var n = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (n += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var b = ar();
          b ? n += b : n += ye();
          var u;
          e === null ? u = "null" : G(e) ? u = "array" : e !== void 0 && e.$$typeof === s ? (u = "<" + (D(e.type) || "Unknown") + " />", n = " Did you accidentally export a JSX literal instead of a component?") : u = typeof e, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", u, n);
        }
        var c = tr(e, r, t, i, l);
        if (c == null)
          return c;
        if (o) {
          var E = r.children;
          if (E !== void 0)
            if (a)
              if (G(E)) {
                for (var A = 0; A < E.length; A++)
                  Ce(E[A], e);
                Object.freeze && Object.freeze(E);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ce(E, e);
        }
        if (k.call(r, "key")) {
          var _ = D(e), g = Object.keys(r).filter(function(dr) {
            return dr !== "key";
          }), X = g.length > 0 ? "{key: someKey, " + g.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!xe[_ + X]) {
            var fr = g.length > 0 ? "{" + g.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, X, _, fr, _), xe[_ + X] = !0;
          }
        }
        return e === f ? ir(c) : or(c), c;
      }
    }
    function lr(e, r, t) {
      return _e(e, r, t, !0);
    }
    function sr(e, r, t) {
      return _e(e, r, t, !1);
    }
    var ur = sr, cr = lr;
    N.Fragment = f, N.jsx = ur, N.jsxs = cr;
  })()), N;
}
var Te;
function Jr() {
  return Te || (Te = 1, process.env.NODE_ENV === "production" ? Y.exports = zr() : Y.exports = Gr()), Y.exports;
}
var Kr = Jr();
const tt = ({
  children: d,
  language: s = Q,
  appResources: p
}) => {
  const f = br(
    () => Ur(s, p),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return gr(() => {
    f.language !== s && f.changeLanguage(s);
  }, [s, f]), /* @__PURE__ */ Kr.jsx(mr, { i18n: f, children: d });
}, Hr = (d) => {
  const { t: s, i18n: p, ready: f } = vr(d);
  return { t: s, i18n: p, ready: f };
}, at = () => Hr("common");
export {
  Q as DEFAULT_LANGUAGE,
  tt as I18nProvider,
  rt as LANGUAGE_OPTIONS,
  hr as SHARED_NAMESPACES,
  et as SUPPORTED_LANGUAGES,
  it as i18n,
  Ur as initI18n,
  Hr as useAppTranslation,
  at as useCommonTranslation
};
